MOVE.DateFormat = (function (MOVE) {
  // MM/DD/yyyy format
  var getFormattedDate = function (date) {
    var year = date.getFullYear();
    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : '0' + month;
    var day = date.getDate().toString();
    day = day.length > 1 ? day : '0' + day;
    return month + '/' + day + '/' + year;
  };

  MOVE.DateFormat =
  {
    getFormattedDate: getFormattedDate
  };

  return MOVE.DateFormat;
})(MOVE || {});


// WEBPACK FOOTER //
// ./shared_non_critical/date_format.js